import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  card: {
    backgroundColor: theme.palette.white,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    overflow: 'hidden',
  },
  filtersRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
    flexWrap: 'wrap',
  },
  searchInput: {
    minWidth: 200,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    gap: theme.spacing(1),
  },
  pagination: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  chipLow: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
    fontWeight: 700,
    height: 21,
  },
  chipMedium: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.common.white,
    fontWeight: 700,
    height: 21,
  },
  chipHigh: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
    fontWeight: 700,
    height: 21,
  },
  iconCell: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  toolIcon: {
    width: 20,
    height: 20,
    objectFit: 'contain',
    flexShrink: 0,
  },
}))

export default useStyles
